import React, { useEffect, useState } from 'react'
import {
  Box,
  FormControlLabel,
  Grid,
  InputLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core'
import { useForm } from 'react-hook-form'
import { isEmpty } from 'lodash'

import { Container, Page } from 'components'
import {
  Header,
  LiaReportPdf,
  ReportVersionExistsDialog,
  ReportVersionTable,
  LiaForm,
} from './components'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import useStyles from './styles'
import constants from 'constants/index'
import helpers from 'helpers'

const LiaReport = () => {
  const [exportingPdf, setExportingPdf] = useState(false)
  const [refresher, setRefresher] = useState(false)
  const [reportVersionExistsOpen, setReportVersionExistsOpen] = useState(false)
  const [currentReportVersion, setCurrentReportVersion] = useState()
  const [isComplete, setIsComplete] = useState(true)
  const [dataProcesses, setDataProcesses] = useState([])
  const [loadingDataProcess, setLoadingDataProcess] = useState(false)

  const classes = useStyles()

  const snackbar = useSnackbar()

  const { lia } = constants.reports.DESCRIPTION

  const getDataProcesses = async () => {
    setLoadingDataProcess(true)
    try {
      const response = await service.dponet.dataProcesses.getWithLiaAnswers({})
      setDataProcesses(response?.data?.dataProcesses)
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(error?.response?.data?.error),
        variant: 'error',
      })
    }
    setLoadingDataProcess(false)
  }

  const { control, watch, errors, triggerValidation, clearError } = useForm({
    validationSchema: LiaForm.schemaLiaForm(!isComplete),
    defaultValues: {
      departmentId: '',
      dataProcess: null,
    },
  })

  const generatePdfLiaReport = async () => {
    if (!isComplete) await triggerValidation()
    if (!isEmpty(errors)) return

    if (isComplete) await getDataProcesses()

    if (!loadingDataProcess) {
      if (!!currentReportVersion?.id) {
        return setReportVersionExistsOpen(true)
      }
      setExportingPdf(true)
    }
  }

  const handleChange = (event) => {
    setIsComplete(event.target.value === 'complete')
  }

  useEffect(() => {
    if (exportingPdf && isEmpty(dataProcesses)) {
      setExportingPdf(false)
      return snackbar.open({
        message: 'Não existem processos disponíveis para gerar esse relátorio',
        vaiant: 'error',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataProcesses, exportingPdf])

  return (
    <Page className={classes.root} title="Relatório de Legítimo Interesse">
      <Container maxWidth={false} spacingXl={15} spacingLg={10} spacingMd={5}>
        <Box py={5}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Header
                type="lia"
                reportTour="lia"
                isLoading={loadingDataProcess}
                buttonAction={generatePdfLiaReport}
                disabled={!!exportingPdf}
                title={lia.title}
                description={lia.content}
              />
            </Grid>
            <Grid item xs={12}>
              <InputLabel className={classes.label}>
                Escolha a versão do relatório:
              </InputLabel>
              <RadioGroup
                value={isComplete ? 'complete' : 'unitary'}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="complete"
                  control={<Radio classes={{ checked: classes.checked }} />}
                  className={classes.radioLabel}
                  label="Relatório Completo (todos os processos que contém LIA)"
                />
                <FormControlLabel
                  value="unitary"
                  className={classes.radioLabel}
                  control={<Radio classes={{ checked: classes.checked }} />}
                  label="Relatório Unitário (somente de um processo)"
                />
              </RadioGroup>
            </Grid>
            {!isComplete && (
              <Grid item xs={12}>
                <LiaForm.Form
                  control={control}
                  watch={watch}
                  errors={errors}
                  clearError={clearError}
                  setDataProcesses={setDataProcesses}
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <ReportVersionTable
                currentReportVersion={currentReportVersion}
                kind={constants.reportVersions.KIND.LIA}
                refresher={refresher}
                setCurrentReportVersion={setCurrentReportVersion}
              />
            </Grid>
          </Grid>
        </Box>
        <LiaReportPdf
          dataProcesses={dataProcesses}
          exportingPdf={exportingPdf}
          shouldCreateVersion={!currentReportVersion?.id}
          refresh={() => setRefresher(!refresher)}
          setExportingPdf={setExportingPdf}
        />
        <ReportVersionExistsDialog
          currentReportVersion={currentReportVersion}
          exportAction={() => setExportingPdf(true)}
          open={reportVersionExistsOpen}
          setCurrentReportVersion={setCurrentReportVersion}
          setOpen={setReportVersionExistsOpen}
        />
      </Container>
    </Page>
  )
}
export default LiaReport
